module.exports = __webpack_public_path__ + "media/images/browsers/uc-browser-59f64f536393f9e861bc745521065466.svg";